import { createContext } from "react";

// フィーチャーフラグの型定義
export type FeatureFlags = {
  enableNewCustomerScreen: boolean;
  enableKarteModelSettings: boolean;
  enableAiAppModelSettings: boolean;
  enableScopedDocumentApps: boolean;
  enableRecordingSessions: boolean;
  enableEditCustomerVisitFields: boolean;
  enableEditCustomerFields: boolean;
  enableEsConnectionSettings: boolean;
};

// デフォルトのフィーチャーフラグ設定
export const DEFAULT_FEATURE_FLAGS: FeatureFlags = {
  enableNewCustomerScreen: false,
  enableKarteModelSettings: false,
  enableAiAppModelSettings: false,
  enableScopedDocumentApps: false,
  enableRecordingSessions: false,
  enableEditCustomerVisitFields: false,
  enableEditCustomerFields: false,
  enableEsConnectionSettings: false,
};

export type FeatureFlagsContextType = {
  flags: FeatureFlags;
  loaded: boolean;
  updateFlag: (key: keyof FeatureFlags, value: boolean) => void;
  resetFlags: () => void;
};

export const FeatureFlagsContext = createContext<
  FeatureFlagsContextType | undefined
>(undefined);
